import { render, staticRenderFns } from "./StackedColumn.vue?vue&type=template&id=3db68bbb&scoped=true&"
import script from "./StackedColumn.vue?vue&type=script&lang=js&"
export * from "./StackedColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db68bbb",
  null
  
)

export default component.exports